import moment from "moment";
import { formatDateISO, formatDateTimeISO } from "./commonHelper";

/**
 * Mốc ngày MẶC ĐỊNH của các màn có bộ lọc theo ngày (Danh sách biên lai, Hóa đơn điện tử).
 *
 * Vì sao cần: `iniState` của reducer là biến cấp module — chỉ chạy MỘT LẦN lúc nạp ứng dụng.
 * Mốc "đến ngày" của Danh sách biên lai lại có cả GIỜ:PHÚT và lọc `Ngay_thu <= den_ngay`
 * (SP `ACC_BienLaiThu_SelectPaging`, nhánh `@loc_theo_gio = 1`) ⇒ phiếu lập SAU lúc mở phần
 * mềm không bao giờ hiện ra, bấm Làm mới bao nhiêu lần cũng vậy vì tham số gửi đi y hệt.
 * Hóa đơn nhẹ hơn (lọc theo NGÀY, SP có `DATEADD(DAY, 1, ...)`) nhưng để tab qua đêm là hỏng.
 *
 * Cách làm: mỗi mốc tự nhớ giá trị nó vừa sinh ra. Bấm Làm mới, nếu giá trị trên bộ lọc vẫn
 * ĐÚNG BẰNG giá trị nó sinh (người dùng chưa động vào) thì sinh lại theo thời điểm hiện tại;
 * người dùng đã tự chọn mốc khác thì GIỮ NGUYÊN lựa chọn của họ.
 */
const taoMoc = (sinh: () => string) => {
  let hienHanh = sinh();
  return {
    /** Giá trị mặc định đang hiệu lực — dùng cho `iniState` của reducer. */
    lay: () => hienHanh,
    /** Trả về mốc đã kéo tới hiện tại nếu người dùng chưa sửa; ngược lại giữ nguyên. */
    lamMoi: (giaTri: unknown) => {
      if (giaTri !== hienHanh) return giaTri;
      hienHanh = sinh();
      return hienHanh;
    },
    /**
     * Người dùng vừa chọn "tới giờ hiện tại" (chọn hôm nay ở ô Đến ngày) → coi như mốc tự sinh,
     * để Làm mới về sau vẫn kéo tiếp tới hiện tại thay vì đóng băng ở phút lúc chọn.
     */
    ghiNhanNeuLaHienTai: (giaTri: unknown) => {
      if (
        typeof giaTri === "string" &&
        moment(giaTri).isSame(moment(), "minute")
      )
        hienHanh = giaTri;
    },
  };
};

/** 00:00 hôm nay (giờ địa phương). */
const dauNgayHomNay = () => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
};

// Danh sách biên lai — lọc tới từng PHÚT.
export const mocTuNgayBienLai = taoMoc(() =>
  formatDateTimeISO(dauNgayHomNay()),
);
export const mocDenNgayBienLai = taoMoc(() => formatDateTimeISO(new Date()));

// Tổng hợp nhập học — mặc định không đặt ngày; mốc này chỉ để Làm mới kéo "đến giờ hiện tại".
export const mocDenNgayNhapHoc = taoMoc(() => formatDateTimeISO(new Date()));

/** Ô "Từ ngày" có giờ: 00:00 của ngày đó. */
export const dauNgayCua = (v: Date | string) =>
  formatDateTimeISO(moment(v).startOf("day").toDate());

/** Ô "Đến ngày" có giờ: hôm nay → giờ hiện tại; ngày khác → 23:59. */
export const cuoiNgayCua = (v: Date | string) =>
  moment(v).isSame(moment(), "day")
    ? formatDateTimeISO(new Date())
    : formatDateTimeISO(
        moment(v).startOf("day").hour(23).minute(59).toDate(),
      );

// Hóa đơn điện tử — lọc theo NGÀY.
export const mocTuNgayHoaDon = taoMoc(() => formatDateISO(new Date()));
export const mocDenNgayHoaDon = taoMoc(() => formatDateISO(new Date()));
